var app = {
	header: {
		build: "Build",
		closeButton: "Zavrieť",
		copyrightLabel: "Autorské práva",
		helpLabel: "Pomoc",
		legalNoticeLabel: "Právne oznámenie",
		logoutButton: "Odhlásiť",
		menuLabel: "Menu",
		module: "Modul",
		noUserDataLabel: "Nie sú dostupné žiadne údaje o používateľovi",
		notificationsLabel: "Notifikácie",
		privacyPolicyLabel: "Zásady ochrany osobných údajov",
		serviceAppLabel: "Servisná aplikácia",
		settingsLabel: "Nastavenia",
		shopLabel: "Obchod",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		softwareInformation: "Informácie o softvéri",
		userLabel: "Profil",
		userProfileLinkText: "Profil používateľa",
		version: "Verzia"
	}
};
var contentLoadingError = "Obsah sa nepodarilo načítať";
var dashboard = {
	cancel: {
		button: "Zrušiť"
	},
	edit: {
		button: "Upraviť"
	},
	reset: {
		button: "Resetovať"
	},
	save: {
		button: "Uložiť"
	},
	share: {
		button: "Zdieľať"
	}
};
var filter = {
	clear: "Resetovať filtre",
	clearAll: "Resetovať všetky filtre"
};
var general = {
	nextButton: "Ďalej",
	prevButton: "Späť",
	resetButton: "Resetovať"
};
var locationMap = {
	locationLink: {
		label: "K miestu"
	}
};
var machineDiscontinuation = {
	linkText: "Dozvedieť sa viac"
};
var notifications = {
	button: {
		loadMore: "Načítať viac"
	},
	date: {
		lastMonth: "Minulý mesiac",
		lastWeek: "Minulý týždeň",
		older: "Staršie",
		thisMonth: "Tento mesiac",
		thisWeek: "Tento týždeň",
		today: "Dnes",
		yesterday: "Včera"
	},
	error: {
		general: "Aktuálne nie je možné zobraziť notifikácie. Skúste to prosím neskôr.",
		unauthorized: "Pre zobrazenie notifikácií sa prosím prihláste"
	},
	info: {
		activateSettings: "Pre prijímanie notifikácií prosím aktivujte ich v nastaveniach",
		noNotification: "Aktuálne pre vás nie sú žiadne správy."
	},
	title: "Notifikácie"
};
var results = {
	counter: {
		label: "výsledkov"
	}
};
var scrollToTop = {
	label: "Posunúť nahor"
};
var slider = {
	nextButton: {
		label: "Ďalší slide"
	},
	paginationBullet: {
		label: "Slide"
	},
	prevButton: {
		label: "Predchádzajúci slide"
	}
};
var sorting = {
	ascending: "Vzostupne",
	descending: "Zostupne"
};
var userAccount = {
	address: {
		label: "Poštová adresa"
	},
	email: {
		label: "Email"
	},
	language: {
		label: "Jazyk",
		locale: "Lokalita",
		select: "Vybrať jazyk",
		settings: "Nastavenia jazyka"
	},
	loggedOut: {
		message: "Nie ste prihlásený"
	},
	login: {
		button: "Prihlásiť"
	},
	name: {
		label: "Meno"
	},
	phone: {
		label: "Telefón"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filtrovať stroje",
			label: "Stroje",
			option: {
				all: "Všetky stroje"
			},
			select: "Vybrať stroj"
		},
		period: {
			label: "Obdobie",
			option: {
				currentMonth: "Tento mesiac",
				currentWeek: "Tento týždeň",
				lastMonth: "Minulý mesiac",
				lastWeek: "Minulý týždeň",
				today: "Dnes",
				yesterday: "Včera"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Moje widgety"
	},
	noDescriptionAvailable: "Popis nie je k dispozícii.",
	widget: {
		SampleMyMachines: {
			title: "Moje stroje"
		},
		SampleMyServiceCalls: {
			title: "Servisné volania"
		},
		SampleMyTrackingList: {
			title: "Zoznam sledovania"
		},
		SampleMyUserAccount: {
			title: "Môj profil"
		},
		SampleOperationalStatesChart: {
			title: "Prevádzkové stavy"
		},
		SampleWidgetFilter: {
			title: "Nastavenia filtra"
		},
		SampleWorkloadBalanceChart: {
			title: "Vyváženie pracovnej záťaže"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	general: general,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, general, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
